import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import {
  KHATTABAT_USER_ACTIVE_FEATURES,
  KHATTABAT_USER_FEATURE_SETS,
  KHATTABAT_USER_FEATURE_SET_ACTIVE_FEATURES
} from "../../../../constants/user-profile";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";
import KhattabatUserFeatureRow from "./KhattabatUserFeatureRow";

const KhattabatUserFeatures = withLiteObserverAndTheme((props) => {
  const { colors } = props.theme;
  const status = getUserAdvancedStore().getUserSubscriptionStatus.get();

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Stack spacing={1.5}>
        <KhattabatUserFeatureRow
          labelKey="ACTIVE_FEATURE_SETS"
          badges={KHATTABAT_USER_FEATURE_SETS(status)}
          inactiveColor={colors.all.gray}
        />
        <KhattabatUserFeatureRow
          labelKey="ACTIVE_FEATURES"
          badges={KHATTABAT_USER_ACTIVE_FEATURES(status)}
          inactiveColor={colors.all.gray}
        />
        <KhattabatUserFeatureRow
          labelKey="FEATURE_SET_ACTIVE_FEATURES"
          badges={KHATTABAT_USER_FEATURE_SET_ACTIVE_FEATURES(status)}
          inactiveColor={colors.all.gray}
        />
      </Stack>
    </Paper>
  );
});

export default KhattabatUserFeatures;
